import React from 'react';
import { Chip, Grid } from '@mui/material';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import { GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { RowAction } from '../../../components/row-action';
import { usePagedList } from '../../../hooks/use-paged-list';
import { useManagementUnitSearchController } from './context/management-unit-search-controller';
import { useManagementUnitSearchState } from './context/management-unit-search-context';
import ManagementUnitAppService from '../../../application/platform/apm/management-unit/management-unit-app-service';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { booleanFilterValue } from '../../../utils/filter-options';
import { PagedGrid } from '../../../components/paged-grid';
import { DeleteAction, EditAction } from '../../../components/row-actions';
import { ManagementUnitDrawer } from './components/management-unit-drawer';

const STATUS_OPTIONS = [{ value: 'true', label: 'Ativa' }, { value: 'false', label: 'Inativa' }];

export function ManagementUnitSearchComponent() {
    const ctrl = useManagementUnitSearchController();
    const { parameters, searchTrigger, drawer } = useManagementUnitSearchState();
    const list = usePagedList(ManagementUnitAppService.list, parameters, searchTrigger, 'Não foi possível carregar as unidades gestoras');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'name', headerName: 'Nome', flex: 1, minWidth: 260 },
        {
            field: 'isActive', headerName: 'Situação', width: 120,
            renderCell: (params) => <Chip size="small" color={params.value ? 'success' : 'default'} label={params.value ? 'Ativa' : 'Inativa'} />
        },
        { field: 'biddingCount', headerName: 'Licitações', width: 110, type: 'number' },
        {
            field: 'actions', headerName: 'Ações', width: 130, sortable: false,
            renderCell: (params) => {
                const inUse = params.row.biddingCount > 0;
                return (
                    <React.Fragment>
                        <RowAction
                            title={params.row.isActive ? 'Inativar' : 'Ativar'}
                            color={params.row.isActive ? 'success' : 'default'}
                            onClick={() => ctrl.handleToggleStatus(params.row)}
                        >
                            {params.row.isActive ? <ToggleOnIcon fontSize="small" /> : <ToggleOffIcon fontSize="small" />}
                        </RowAction>
                        <EditAction onClick={() => ctrl.openDrawer(params.row)} />
                        <DeleteAction
                            title={inUse ? 'Possui licitações vinculadas: inative-a em vez de excluir' : 'Excluir'}
                            disabled={inUse}
                            onClick={() => ctrl.handleDelete(params.row)}
                        />
                    </React.Fragment>
                );
            }
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Unidades Gestoras"
                    subtitle="Unidades responsáveis pelas licitações publicadas no portal"
                    breadcrumbs={[{ label: 'Unidades Gestoras' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={8}>
                        <FilterInput label="Nome" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FilterSelect
                            label="Situação"
                            name="select-status"
                            value={booleanFilterValue(parameters.isActive)}
                            options={STATUS_OPTIONS}
                            emptyLabel="Todas"
                            onChange={ctrl.handleOnChange}
                        />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <PagedGrid
                    columns={columns}
                    list={list}
                    parameters={parameters}
                    onPaginationChange={ctrl.handlePaginationChange}
                    addLabel="Nova Unidade Gestora"
                    onAdd={() => ctrl.openDrawer()}
                />
            </Grid>

            <ManagementUnitDrawer
                open={drawer.open}
                initial={drawer.unit}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
